import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {BwGraph} from '../models/bwGraph';
import {Observable} from 'rxjs';

@Injectable()
export class GraphService {

  constructor(private httpClient: HttpClient) {
  }

  getHeartbeatOrQrdMlrGraphsInformation(heartbeatOrQrdMlr: string) {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/' + heartbeatOrQrdMlr);
  }

  getQfdMlrGraphsInformation() {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/qfd-mlr-latency-graph-data');
  }

  loadGraphForQfdMlr(market2Transport) {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/qfd-mlr-graph-latency?channelPop=' + market2Transport);
  }

  getBwGraphs(): Observable<BwGraph[]> {
    return this.httpClient.get<BwGraph[]>(environment.baseUrlWs + '/api/bw-graph');
  }

  getQedMarketDataGraphs(page: number, pageSize: number): Observable<any[]> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());
    return this.httpClient.get<any[]>(environment.baseUrlWs + '/api/qed-market-data-graph', {params});
  }

  deleteBwGraph(id: number) {
    return this.httpClient.delete(environment.baseUrlWs + '/api/bw-graph/' + id);
  }

  addBwGraph(bwGraph: BwGraph) {
    return this.httpClient.post(environment.baseUrlWs + '/api/bw-graph', bwGraph);
  }

  editBwGraph(id: number, bwGraph: BwGraph) {
    return this.httpClient.put(environment.baseUrlWs + '/api/bw-graph/' + id, bwGraph);
  }
}
